module.exports = __webpack_public_path__ + "static/media/DPET.691778b6.png";